import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getSpecializations } from '../../../httpClient/Requests/Api/XTRF/system'
import axios from 'axios'
import { PrefixType } from '../../interfaces/Prefix'
import { OtherLookupFormat, OtherLookupState } from '../../interfaces/OtherLookupState'

export const initialState: OtherLookupState = {
    data: [],
    loading: false,
    error: null,
}

export const fetchSpecializations = (prefix: PrefixType) =>
    createAsyncThunk(`${prefix}/specializations/fetchSpecializations`, async (_: void, { signal }) => {
        const source = axios.CancelToken.source()
        signal.addEventListener('abort', () => {
            source.cancel()
        })
        if (prefix.includes('XTRF')) {
            const response = await getSpecializations<OtherLookupFormat[]>()
            return response.data
        }
    })

const specializationsSlice = (prefix: PrefixType) =>
    createSlice({
        name: `${prefix}/specializations`,
        initialState,
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(fetchSpecializations(prefix).pending, (state) => ({ ...state, loading: true, error: null }))
            builder.addCase(fetchSpecializations(prefix).fulfilled, (state, action) => ({
                ...state,
                data: action.payload,
                loading: false,
                error: null,
            }))
            builder.addCase(fetchSpecializations(prefix).rejected, (state, action) => ({
                ...state,
                loading: false,
                error: action.error,
            }))
        },
    })

const specializations = (prefix: PrefixType) => specializationsSlice(prefix).reducer

export default specializations
